import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/context-aware.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const render = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

render();

// Register service worker for push notifications
// Only register in production (dev mode serves raw sw.js with ES6 imports which don't work)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/sw.js')
      .catch(function(error) {
        console.error('ServiceWorker registration failed:', error);
      });
  });
}

// Hot Module Replacement (HMR)
if (import.meta.hot) {
  import.meta.hot.accept('./App', () => {
    render();
  });
}
